import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import { LiveRegion } from './live-region';
import { IWithLiveRegionProps } from './types';

export const withLiveRegionProp = <P extends object>(WrappedComponent: React.ComponentType<P>): React.ComponentType<P & IWithLiveRegionProps> => {
  const HoC: React.FC<P & IWithLiveRegionProps> = (props: P & IWithLiveRegionProps) => {
    const { screenReaderText, ...rest } = props;
    return (
      <>
        <WrappedComponent {...(rest as P)} />
        <LiveRegion screenReaderText={screenReaderText} {...(rest as P)} />
      </>
    );
  };
  HoC.displayName = `WithLiveRegion(${getDisplayName(WrappedComponent)})`;

  hoistNonReactStatics(HoC, WrappedComponent);

  return HoC;
};
